import React from 'react';

const SelectedProductsPanel = ({ selectedProducts, onClearSelection, onViewDetails, onDeepAnalysis, onCompare, isAnalysisLoading, isCompareLoading }) => {
    if (selectedProducts.length === 0) return null;

    const getBestProduct = () => {
        return selectedProducts.reduce((best, current) =>
            (current.bettr_score || 0) > (best.bettr_score || 0) ? current : best
        );
    };

    const getAverageScore = () => {
        const scores = selectedProducts.map(p => p.bettr_score || 0).filter(s => s > 0);
        return scores.length > 0 ? (scores.reduce((a, b) => a + b, 0) / scores.length).toFixed(1) : 0;
    };

    const getCommonBrands = () => {
        const brandCount = {};
        selectedProducts.forEach(p => {
            const brand = p.extracted_brand_name;
            if (brand) brandCount[brand] = (brandCount[brand] || 0) + 1;
        });
        return Object.entries(brandCount).sort(([,a], [,b]) => b - a);
    };

    const bestProduct = getBestProduct();
    const avgScore = getAverageScore();
    const commonBrands = getCommonBrands();

    return (
        <div className="selected-products-panel">
            <div className="panel-header">
                <div className="panel-title">
                    <span className="selection-count">{selectedProducts.length}</span>
                    <span className="selection-label">Products Selected</span>
                </div>
                <button className="clear-selection-btn" onClick={onClearSelection}>
                    Clear All
                </button>
            </div>

            <div className="brands-summary">
                <span className="brands-label">Brands:</span>
                <span className="brands-list">
                    {commonBrands.map(([brand, count], index) => (
                        <span key={brand} className="brand-tag">
                            {brand} ({count}){index < commonBrands.length - 1 ? ', ' : ''}
                        </span>
                    ))}
                </span>
            </div>



            <div className="selected-products-grid">
                {selectedProducts.map((product, index) => (
                    <div key={product.product_id} className="selected-product-item">
                        <div className="product-number">{index + 1}</div>
                        <div className="product-image">
                            <img
                                src={product.image_urls[0]}
                                alt={product.product_name}
                                onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src='https://via.placeholder.com/60x60/f0f0f0/666666?text=No+Image';
                                }}
                            />
                        </div>
                        <div className="product-info">
                            <h5>{product.product_name.split(',')[0]}</h5>
                            <p className="brand">{product.extracted_brand_name}</p>
                            <div className="product-score">
                                {product.bettr_score > 0 && (
                                    <span className="score">{product.bettr_score}%</span>
                                )}
                            </div>
                        </div>
                        <button
                            className="view-details-btn"
                            onClick={() => onViewDetails(product)}
                        >
                            View
                        </button>
                    </div>
                ))}
            </div>

            <div className="panel-actions">
                <button
                    className="compare-btn"
                    onClick={onCompare}
                    disabled={isCompareLoading || selectedProducts.length < 2}
                >
                    {isCompareLoading ? '🔄 Comparing...' : `🔍 Compare (${selectedProducts.length})`}
                </button>
                <button
                    className="analyze-btn"
                    onClick={onDeepAnalysis}
                    disabled={isAnalysisLoading}
                >
                    {isAnalysisLoading ? '🔄 Analyzing...' : '📈 Analyse'}
                </button>
            </div>
        </div>
    );
};

export default SelectedProductsPanel;
